import axios from '@axios'

const route = 'report/schedule/schedule_summary_cancelled'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    index(context, { itemsPerPage, page, filters }) {
      return axios.post(`${route}?page=${page}&items_per_page=${itemsPerPage}`, filters)
    },

    getExportExcel(constext, data) {
      return axios.post(`${route}/export_excel`, data, { responseType: 'blob' })
    },

    getExportPdf(constext, data) {
      return axios.post(`${route}/export_pdf`, data, { responseType: 'blob' })
    },

  },
}
